import { selector } from 'recoil';

import { goodOptionListState, goodTabInfoState } from '@mo-recoil/good/atom';

export const withGoodTabIndex = selector({
  key: 'withGoodTabIndexMo',
  get: ({ get }) => {
    return get(goodTabInfoState);
  },
});

export const withOptionTotalPrice = selector({
  key: 'withOptionTotalPrice',
  get: ({ get }) => {
    const selectedOptionList = get(goodOptionListState);

    const totalPrice = selectedOptionList.reduce((sum, curr) => sum + curr.discountPrice * curr.count, 0);
    const totalFormattedPrice = selectedOptionList.reduce(
      (sum, curr) => sum + curr.discountFormattedPrice * curr.count,
      0
    );

    return {
      totalPrice,
      totalFormattedPrice,
    };
  },
});
